import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { ImageList, ImageListItem } from '@mui/material';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import { createStyledImageListItemBar } from '../../helpers';
import one from '../../Assets/CharacterBasedDrawings/1.jpg';
import two from '../../Assets/CharacterBasedDrawings/2.jpg';
import three from '../../Assets/CharacterBasedDrawings/3.jpg';
import four from '../../Assets/CharacterBasedDrawings/4.jpg';
import five from '../../Assets/CharacterBasedDrawings/5.jpg';
import six from '../../Assets/CharacterBasedDrawings/6.jpg';
import seven from '../../Assets/CharacterBasedDrawings/7.jpg';
import eight from '../../Assets/CharacterBasedDrawings/8.jpg';
import nine from '../../Assets/CharacterBasedDrawings/9.jpg';
import ten from '../../Assets/CharacterBasedDrawings/10.jpg';
import eleven from '../../Assets/CharacterBasedDrawings/11.jpg';
import twelve from '../../Assets/CharacterBasedDrawings/12.jpg';
import ni from '../../Assets/CharacterBasedDrawings/ni.jpg';
import pi from '../../Assets/CharacterBasedDrawings/pikipi.jpg';

const illustrations = [
  {
    img: one,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: two,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: three,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: four,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: five,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: six,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: seven,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: eight,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: nine,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: ni,
    title: 'Character Portrait - Digital Art',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: pi,
    title: 'Character Portrait - Digital Art',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: ten,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: eleven,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: twelve,
    title: 'Digital painting - Character Study',
    author: 'Nikoletta Papakonstantinou',
  },
];

function Illustrations() {
  // Image viewer state
  const [illustrationImage, setCurrentIllustrationImage] = React.useState(0);
  const [isIllustrationViewerOpen, setIsIllustrationViewerOpen] = React.useState(false);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Digital paintings and Drawings on paper</strong>
        </h1>
        <p style={{ color: 'black' }}>All with a sense of humor.</p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>

      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {illustrations.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentIllustrationImage(index);
                setIsIllustrationViewerOpen(true);
              },
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>

      {/* Image Viewer at the top level for full-screen display */}
      {createImageViewer({
        isOpen: isIllustrationViewerOpen,
        images: illustrations.map(item => item.img),
        currentIndex: illustrationImage,
        onClose: () => setIsIllustrationViewerOpen(false),
      })}
    </Container>
  );
}
export default Illustrations;
